import React, { useState } from 'react';
import { Table } from '../common';
import Paginator from '../common/tables/Paginator';
import AWSAccountRequest from '../../models/entities/AWSAccountRequest';
import ApprovalsAWSAccountsTableRow from './ApprovalsAWSAccountsTableRow';

interface ApprovalsAWSAccountsTableProps {
    filteredAWSAccounts: AWSAccountRequest[];
}

const ApprovalsAWSAccountsTable = ({
    filteredAWSAccounts,
}: ApprovalsAWSAccountsTableProps) => {
    const [accountsOnPage, setAccountsOnPage] = useState<AWSAccountRequest[]>([]);
    return (
        <Table
            firstColumnAlign='left'
            footer={
                <Paginator
                    data={filteredAWSAccounts}
                    onPageChange={(accounts: AWSAccountRequest[]) => {
                        setAccountsOnPage(accounts);
                    }}
                />
            }
        >
            <Table.Head>
                <Table.Head.Row>
                    <Table.Head.Cell>Account Name</Table.Head.Cell>
                    <Table.Head.Cell className="em-u-text-align-center">Type</Table.Head.Cell>
                    <Table.Head.Cell className="em-u-text-align-center">Status</Table.Head.Cell>
                    <Table.Head.Cell className="em-u-text-align-center">Action</Table.Head.Cell>
                </Table.Head.Row>
            </Table.Head>
            <Table.Body>
                {accountsOnPage.map((account: AWSAccountRequest) => {
                    return (
                        <ApprovalsAWSAccountsTableRow
                            key={account.id}
                            account={account}
                        />
                    );
                })}
            </Table.Body>
        </Table>
    );
};

export default ApprovalsAWSAccountsTable;
